module.exports = __webpack_public_path__ + "static/img/img3.e7816eb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/downloads/img3.png
// module id = 8tiZ
// module chunks = 23